/* Suivi des leads B2B vers GA4 G-PEQG97MYKT via le gtag de l'app Google & YouTube.
   L'app n'installe gtag qu'apres consentement "analyse" : sans gtag, rien ne part.
   (Shopify.analytics.publish n'est PAS relaye vers GA4 par l'app sur cette boutique, verifie le 15/10/2026.)
   Evenements : generate_lead (devis / contact), clic_telephone, clic_email, ajout_devis. Aucune donnee personnelle envoyee. */
(function () {
  if (window.__ppLeads) return;
  window.__ppLeads = true;

  function pub(name, data, tries) {
    if (typeof window.gtag === 'function') {
      var p = { send_to: 'G-PEQG97MYKT' };
      for (var k in data) p[k] = data[k];
      window.gtag('event', name, p);
    } else if (tries) {
      setTimeout(function () { pub(name, data, tries - 1); }, 500);
    }
  }

  function zone(el) {
    if (el.closest('header, .shopify-section-group-header-group')) return 'entete';
    if (el.closest('footer, .shopify-section-group-footer-group')) return 'pied_de_page';
    return 'contenu';
  }

  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest && e.target.closest('a[href^="tel:"], a[href^="mailto:"], .rfq-btn');
    if (!el) return;
    if (el.classList.contains('rfq-btn')) {
      pub('ajout_devis', { emplacement: zone(el), page: location.pathname });
      return;
    }
    var href = el.getAttribute('href') || '';
    pub(href.indexOf('tel:') === 0 ? 'clic_telephone' : 'clic_email', { emplacement: zone(el), page: location.pathname });
  }, true);

  document.addEventListener('GRFQ_form_submitted', function (e) {
    var r = e.detail && e.detail.response;
    if (r && r.success === false) return;
    pub('generate_lead', { lead_type: 'devis', formulaire: 'page_devis' });
  });

  document.addEventListener('GRFQ_quickform_submitted', function () {
    pub('generate_lead', { lead_type: 'devis', formulaire: 'fiche_produit' });
  });

  if (/[?&]contact_posted=true/.test(location.search)) {
    pub('generate_lead', { lead_type: 'contact', formulaire: 'contact', page: location.pathname }, 20);
    try {
      var u = new URL(location.href);
      u.searchParams.delete('contact_posted');
      history.replaceState(history.state, '', u.pathname + u.search + u.hash);
    } catch (e) {}
  }
})();
